export default __webpack_public_path__ + "img/4daa4d8232fd341e92e925971441a282.svg";